import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { RAM_ASK, readRamRuling } from '../engine/actions/ram';

/**
 * useShellRam - a vehicle's ram, ruled by the GM (plan map-display, D).
 *
 * The damage is the GM's call (engine/actions/ram). `press` - the drum's
 * Ram plate - puts the question: the GM, and anyone outside a session,
 * rules alone, on their own screen (`request` is shown by the asks tray;
 * `submit` with the two numbers, or `cancel`); a player's ram goes to the
 * GM as an ask, and strikes when it is answered, on the player's own
 * screen. It strikes the driver and target the GM was ASKED about, or
 * nobody (attack/ram says so in the log). A withdrawn or dismissed ask is
 * no ram.
 *
 * @param {object} args - rulesAlone, ask (useAsks), actorId, actorName, targetId, targetName,
 *   handleRam (useAttackExecution).
 * @returns {{ request: {rammer: string, target: string}|null, press: () => void,
 *   submit: (ruling: {damage: number, bow: number}) => void, cancel: () => void }}
 */
export default function useShellRam(args) {
  // The answer comes back renders later: read the verbs as they are then, not as they were asked.
  const live = useRef(args);
  useLayoutEffect(() => {
    live.current = args;
  });
  // The GM's own question on screen, with the pair it is about: the ruling strikes them or nobody.
  const [pending, setPending] = useState(null);
  const strike = useCallback((ruling, pair) => {
    if (ruling && pair) live.current.handleRam(ruling, pair);
  }, []);
  const press = useCallback(() => {
    const { rulesAlone, ask, actorId, actorName, targetId, targetName } = live.current;
    const pair = { actorId: actorId ?? null, targetId: targetId ?? null };
    const question = { rammer: actorName || 'The vehicle', target: targetName || 'the target' };
    if (rulesAlone) return setPending({ question, pair });
    ask(RAM_ASK, 'gm', question).then((answer) => strike(readRamRuling(answer), pair));
  }, [strike]);
  const submit = useCallback(
    (ruling) => {
      setPending(null);
      strike(readRamRuling(ruling), pending?.pair);
    },
    [strike, pending],
  );
  const cancel = useCallback(() => setPending(null), []);
  return { request: pending?.question ?? null, press, submit, cancel };
}
